.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.section-title {
  align-items: center;
  display: flex;
  gap: 8px;
  margin: 0;
}

.section-icon {
  color: var(--color-muted);
  flex-shrink: 0;
}

.fields {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.link {
  color: var(--color-primary);
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.chip {
  background: var(--color-secondary);
  border-radius: 100px;
  color: var(--color-foreground);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
}

.address-block {
  overflow-wrap: anywhere;
}

.notes-block {
  background: var(--color-secondary);
  border-radius: 8px;
  padding: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
